import axios from "axios";

const instanceTelegram = axios.create({
    baseURL: "https://a4.lineragames.com.br",
    headers: {
      Authorization: ""
    }
  })

export default instanceTelegram;